module.exports = __webpack_public_path__ + "static/media/world-map.e237458f.gif";